import Drawer from './drawer';

const NavigationDrawer = class extends Drawer {
    get openFrom() {
        return window.matchMedia('screen and (max-width: 639px)').matches ? this.getAttribute('mobile-opening') : super.openFrom;
    }
};

export default NavigationDrawer;
